/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneInstagram from 'base/components/standalone/Instagram';

export const DynamicStandaloneInstagram = StandaloneInstagram;
export type DynamicStandaloneInstagramProps = PropsFromComponent<typeof StandaloneInstagram>;

export const DynamicStandaloneInstagramWith = (extras: DynamicStandaloneExtras): typeof StandaloneInstagram => {
    return function DynamicStandaloneInstagram(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Instagram');
        return <StandaloneInstagram {...mergeProps({ options: { theme } }, props)} />;
    }
}